import * as React from 'react';
import { ValuationContext } from '../context/ValuationContext';

export const useValuationContext = () => {
  return React.useContext(ValuationContext);
};
